import { Fragment, type ReactNode } from 'react';

import './breadcrumb.css';
import { ChevronRight } from 'lucide-react';
import { useMatches, type Params } from 'react-router-dom';

import { Separator } from '../ui/separator';
import { SidebarTrigger } from '../ui/sidebar';
import { AuthStatus } from '@/authentication/auth-status';

interface IMatches {
  id: string;
  pathname: string;
  params: Params;
  data: unknown;
  handle: unknown;
}
interface HandleType {
  crumb: (_param?: unknown) => ReactNode;
}
export const BreadCrumb = () => {
  const matches: IMatches[] = useMatches();

  const crumbs = matches
    .filter(
      (match) =>
        Boolean(match.handle) ||
        (match.id !== 'root' && !match.pathname.endsWith('/')), // Filter out root and index routes
    )
    .map((match) => {
      if (
        typeof match.handle === 'object' &&
        match.handle !== null &&
        'crumb' in match.handle
      ) {
        return (match.handle as HandleType).crumb(match.data);
      } else {
        return match.pathname.split('/').reverse()[0];
      }
    });

  return (
    <nav
      aria-label="breadcrumb"
      className="sticky top-0 z-10 flex justify-between items-center
      border border-b-2 border-secondary bg-background pr-4"
    >
      <ol className="breadcrumb">
        <SidebarTrigger />
        <Separator orientation="vertical" className="mr-2 h-4!" />
        {crumbs.map((crumb, index) =>
          crumbs.length - 1 === index ? (
            <li role="listitem" aria-current="page" key={index}>
              {crumb}
            </li>
          ) : (
            <Fragment key={index}>
              <li role="listitem">{crumb}</li>
              <ChevronRight size={16} />
            </Fragment>
          ),
        )}
      </ol>
      <AuthStatus />
    </nav>
  );
};
